import withProps from './private/withProps.tsx';

export default withProps;
